import * as yup from "yup";

import { FORM_FIELDS } from "@constants/form";

export const FILE_INQUIRY = FORM_FIELDS.EMPLOYEE.FILE_INQUIRY;

export const fileInquiryValidation = yup.object().shape({
  [FILE_INQUIRY.FILE_TYPE]: yup.string().required("File type is required"),
  [FILE_INQUIRY.SUBJECT]: yup.string().required("Subject is required"),
  [FILE_INQUIRY.FILE_FROM_DATE]: yup
    .string()
    .required("File from date is required"),
  [FILE_INQUIRY.STATUS]: yup.string(),
  [FILE_INQUIRY.PERFORMANCE_EVALUATION]: yup
    .number()
    .transform((value, originalValue) => (originalValue === "" ? null : value))
    .nullable()
    .typeError("Performance evaluation has to be a number"),
  [FILE_INQUIRY.UNIQUE_NAME]: yup.string().required("Unique name is required"),
});

export type FileInquiryFormDataType = yup.InferType<
  typeof fileInquiryValidation
>;
